import { render, staticRenderFns } from "./AlertasLayout.vue?vue&type=template&id=6d5da3e4"
import script from "./AlertasLayout.vue?vue&type=script&lang=ts"
export * from "./AlertasLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports